/**
 * Video Controls Toggle for Autoplay Videos
 * 
 * Enables tap-to-show-controls on mobile for videos with autoplay enabled.
 * Controls appear on tap and automatically hide after 3 seconds of inactivity.
 */

class VideoControlsToggle {
  constructor() {
    this.hideTimeout = null;
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupVideoControls());
    } else {
      this.setupVideoControls();
    }
  }

  setupVideoControls() {
    // Find all video-media elements with autoplay
    const autoplayVideos = document.querySelectorAll('video-media[autoplay]');
    
    autoplayVideos.forEach(videoMedia => {
      const video = videoMedia.querySelector('video');
      if (!video) return;

      // Add tap/click handler to show controls
      videoMedia.addEventListener('click', (e) => {
        // Don't interfere with other click handlers (like play button)
        if (e.target.matches('button, a[href], button *, a[href] *')) {
          return;
        }

        this.toggleControls(videoMedia, video);
      });

      // Also handle when video is playing/paused
      video.addEventListener('play', () => {
        if (video.controls) {
          this.scheduleHideControls(videoMedia, video);
        }
      });

      video.addEventListener('pause', () => {
        clearTimeout(this.hideTimeout);
      });

      // Hide controls when user interacts with them (after a delay)
      video.addEventListener('controlschange', () => {
        if (video.controls) {
          this.scheduleHideControls(videoMedia, video);
        }
      });
    });
  }

  toggleControls(videoMedia, video) {
    if (video.controls) {
      // Controls are visible, hide them
      video.controls = false;
      videoMedia.removeAttribute('show-controls');
      clearTimeout(this.hideTimeout);
    } else {
      // Controls are hidden, show them
      video.controls = true;
      videoMedia.setAttribute('show-controls', '');
      this.scheduleHideControls(videoMedia, video);
    }
  }

  scheduleHideControls(videoMedia, video) {
    clearTimeout(this.hideTimeout);
    
    // Hide controls after 3 seconds of inactivity
    this.hideTimeout = setTimeout(() => {
      if (video.controls && !video.paused) {
        video.controls = false;
        videoMedia.removeAttribute('show-controls');
      }
    }, 3000);
  }
}

// Initialize when script loads
if (!window.videoControlsToggle) {
  window.videoControlsToggle = new VideoControlsToggle();
}

